import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import SocieteService from "../../../services/Societe";
import makeAnimated from "react-select/animated";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import CardSolde from "./CardSolde";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import CardBoxTwo from "../../../components/cardBox/cardBoxTwo";
import ConfigurerSeuilClient from "../../../ui/ConfigurerSeuilClient";
import UtilsFormule from "../../../utils/UtilsFormule";
import ConfigurerBloquerClient from "../../../ui/ConfigurerBloquerClient";



const FicheFournisseur =({startLoading,stopLoading})=>{

const navigate = useNavigate();
  const [societes, setSocietes] = useState([]);
  const [alertMessage, setAlertMessage] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [idSociete, setIdSociete] = useState(null);
  const [nameSociete, setNameSociete] = useState(null);

  const [btnSoldeClicked, setBtnSoldeClicked] = useState(false);
  const [soldeInfo, setSoldeInfo] = useState(null);
  const [userRole, setUserRole] = useState("");

  //card value by client
  const [onConfigSeuil, setOnConfigSeuil] = useState(false);
  const [onConfigBlock, setOnConfigBlock] = useState(false);

  const [soldeValueClient, setSoldeValueClient] = useState(0);
  const [payementValueClient, setPayementValueClient] = useState(0);
  const [seuilClient, setSeuilClient] = useState(false);
  const [seuilClientvalue, setSeuilClientvalue] = useState(0);
  const [isShowDetailsBtn, setIsShowDetailsBtn] = useState(false);
  const [isShowGeneralDetailsBtn, setIsShowGeneralDetailsBtn] = useState(false);
  const [isShowBlockBtn, setIsShowBlockBtn] = useState(false);

  const [solde, setSolde] = useState(null);
  const [wallet, setWallet] = useState(null);
  const [seuil, setSeuil] = useState(null);
  const [seuilConfig, setSeuilConfig] = useState(null);
  const [impayed, setImpayed] = useState(0);
  const [ca, setCa] = useState(0);
  const [none, setNone] = useState(0);

  const [impayedTotal, setImpayedTotal] = useState(0);
  const [caTotal, setCaTotal] = useState(0);
  const [noneTotal, setNoneTotal] = useState(0);

  const animatedComponents = makeAnimated();
  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }
    setOptions([]);
    startLoading();
    SocieteService.getSocietesClients("CLIENT", "FOURNISSEUR", 1, 0)
      .then((response) => {
        if (response.data["vide"] !== undefined) {
          setAlertMessage("error");
        } else {
          localStorage.setItem("TypeTiersAccount", "C");

          setSocietes(response.data["Societe"]);
          setAlertMessage("success");
          const newOptions = response.data["Societe"].map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.title,
          }));
          console.log("newOptions", newOptions);
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
    TierAccountService.getGeneralInfoBySocieteFournisseur(getCurrentUserId())
      .then((response) => {
        if (response.data.success) {
          setNoneTotal(response.data.none);
          setCaTotal(response.data.ca);
          setImpayedTotal(response.data.impayed);
          setIsShowDetailsBtn(false);
          setIsShowGeneralDetailsBtn(true);
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);


  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdSociete(selectedOption.value);
    setNameSociete(selectedOption.label)
  };

  const getAllSoldesBySocieteAndFournisseur = (e) => {
    TierAccountService.getFicheFournisseurInfoByTiers(getCurrentUserId(), idSociete)
      .then((response) => {
        console.log(response);
        if (response.data.success) {
          setSolde(response.data.solde);
          setWallet(response.data.wallet);
          setSeuil(response.data.seuil);
          setSeuilConfig(response.data.seuilConfig);
          setNone(response.data.none);
          setCa(response.data.ca);
          setImpayed(response.data.impayed);
          setIsShowDetailsBtn(true);
          setIsShowGeneralDetailsBtn(false);
          setIsShowBlockBtn(true);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      });
  };


  const detailsSoldes = () => {
   
    localStorage.setItem("idTiers", idSociete);
    localStorage.setItem("idAccountSolde", solde?.id);

  
      const pdfWindow = window.open();
      pdfWindow.location.href = "/detailsTransactionAccountFournisseur";
    
  };

  const facturesClient = () => {
    // saveIdSociete();
    localStorage.setItem("idTiers", idSociete);
    localStorage.setItem("nameTiers", nameSociete);

    const pdfWindow = window.open();
    pdfWindow.location.href = "/facturesFournisseur";
  };

  const echeanceClient = () => {
    // saveIdSociete();
    localStorage.setItem("idTiers", idSociete);
    localStorage.setItem("nameTiers", nameSociete);

    const pdfWindow = window.open();
    pdfWindow.location.href = "/detailsEcheanceFournisseur";
  };
  const impayedClient = () => {
    // saveIdSociete();
    localStorage.setItem("idTiers", idSociete);
    localStorage.setItem("nameTiers", nameSociete);

    const pdfWindow = window.open();
    pdfWindow.location.href = "/detailsImpayesAccountFournisseur";
  };
  const detailsWallet = () => {
   
    localStorage.setItem("idTiers", idSociete);
    localStorage.setItem("idAccountSolde", wallet?.id);

   
      const pdfWindow = window.open();
      pdfWindow.location.href = "/detailsTransactionAccountFournisseur";
  
  };

  const ficheClient = () => {
    return (
      <>
        {isShowDetailsBtn && (
          <section class="content">
            <div className="row">
              {ca !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    {" "}
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">
                        <div className="row">
                          {" "}
                          <div className="col-md-6">Chiffre d'affaire</div>{" "}
                          <div className="col-md-6 float-right">
                            <button
                              className="btn btn-sm"
                              style={{ color: "white" }}
                              onClick={() => facturesClient()}
                            >
                              {" "}
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span className="info-box-number">{ca}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {none !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">
                        <div className="row">
                          {" "}
                          <div className="col-md-6">Echeance</div>{" "}
                          <div className="col-md-6 float-right">
                            <button
                              className="btn btn-sm"
                              style={{ color: "white" }}
                              onClick={() => echeanceClient()}
                            >
                              {" "}
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>

                      </span>
                      <span className="info-box-number">{none}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {impayed !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    {" "}
                    <span className="info-box-icon">
                      <i class="fas fa-sack-xmark"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">
                        <div className="row">
                          {" "}
                          <div className="col-md-6">Impayé</div>{" "}
                          <div className="col-md-6 float-right">
                            <button
                              className="btn btn-sm"
                              style={{ color: "white" }}
                              onClick={() => impayedClient()}
                            >
                              {" "}
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span className="info-box-number">{impayed}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
         
            </div>
            <div className="row">
              {solde !== null && (
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray">
                    <span className="info-box-icon">
                      <i class="fas fa-money-bill-transfer"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">
                        {" "}
                        <div className="row">
                          {" "}
                          <div className="col-md-9">{solde?.title}</div>{" "}
                          <div className="col-md-3 float-right">
                            <button
                              className="btn btn-sm"
                              style={{ color: "white" }}
                              onClick={() => detailsSoldes()}
                            >
                              {" "}
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span className="info-box-number">{solde?.solde}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        Dernier update{" "}
                        {UtilsFormule.formatDateHours(solde?.lastUpdate)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {wallet !== null && (
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray">
                    <span className="info-box-icon">
                      <i class="fas fa-circle-dollar-to-slot"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">
                        <div className="row">
                          {" "}
                          <div className="col-md-9">{wallet?.title}</div>{" "}
                          <div className="col-md-3 float-right">
                            <button
                              className="btn btn-sm"
                              style={{ color: "white" }}
                              onClick={() => detailsWallet()}
                            >
                              {" "}
                              <i class="fas fa-edit"></i>
                            </button>
                          </div>
                        </div>
                      </span>
                      <span className="info-box-number">{wallet?.solde}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        Dernier update{" "}
                        {UtilsFormule.formatDateHours(wallet?.lastUpdate)}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>

          </section>
        )}
      </>
    );
  };
  const generalClient = () => {
    return (
      <>
        {isShowGeneralDetailsBtn && (
          <section class="content">
            <div className="row">
              {caTotal !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    {" "}
                    <span className="info-box-icon">
                      <i class="fas fa-sack-dollar"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Chiffre d'affaire</span>
                      <span className="info-box-number">{caTotal}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description"></span>
                    </div>
                  </div>
                </div>
              )}
              {noneTotal !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i class="fas fa-hand-holding-dollar"></i>{" "}
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Echeance</span>
                      <span className="info-box-number">{noneTotal}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {impayedTotal !== null && (
                <div className="col-md-4 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    {" "}
                    <span className="info-box-icon">
                      <i class="fas fa-sack-xmark"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Impayé</span>
                      <span className="info-box-number">{impayedTotal}</span>
                      <div className="progress">
                        <div
                          className="progress-bar"
                          style={{ width: "100%" }}
                        />
                      </div>
                      <span className="progress-description">
                        {/* 70% Increase in 30 Days */}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </section>
        )}
      </>
    );
  };
  // const handelNavigation = () => {
  //   navigate('/AllClient')
  // }
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section class="content">
        <div class="row">
          <div class="col-md-12 mb-2">
            {/* <button
              type="submit"
              onClick={() => {
                handelNavigation()
              }}
              className="btn btn-dark float-right "
            >
              Voir tous les clients
            </button> */}
          </div>
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Les Fiches des fournisseurs</h3>
              </div>
              <form className="form-horizontal"></form>
              <div className="card-body">
                <div class="row">
                  <div class="form-group col-4 col-sm-4">
                    <div>
                      <label>Choisir le fournisseur</label>
                      <Select
                        value={selectedOption}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={options}
                        onChange={handleChange}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer">
              

                <button
                  type="submit"
                  onClick={() => {
                    getAllSoldesBySocieteAndFournisseur();
                  }}
                  className="btn btn-dark float-right "
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {ficheClient()}
      {generalClient()}

      {onConfigSeuil && (
        <ConfigurerSeuilClient
          setOnConfigSeuil={setOnConfigSeuil}
          seuilClientvalue={seuilClientvalue}
          clientName={selectedOption?.label}
          idSociete={idSociete}
        />
      )}
      {onConfigBlock && (
        <ConfigurerBloquerClient
          setOnConfigBlock={setOnConfigBlock}
          clientName={selectedOption?.label}
          idSociete={idSociete}
        />
      )}
    </div>
  );
};
export default withLoader(FicheFournisseur)